import { Component, OnInit, ViewChild } from '@angular/core';
import { FilterSettingsModel, GridComponent, SearchSettingsModel, SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { PessoaExamePeriodicidadeConsultaDto } from 'src/app/dtos/periodicidades/pessoa-exame-periodicidade';
import { PessoaExamePeriodicidadeCadastroComponent } from 'src/app/periodicidade/pessoa-exame-periodicidade-cadastro/pessoa-exame-periodicidade-cadastro.component';
import { PacienteService } from 'src/app/servicos/paciente.service';

@Component({
  selector: 'app-paciente-periodicidade-lista',
  templateUrl: './paciente-periodicidade-lista.component.html',
  styleUrls: ['./paciente-periodicidade-lista.component.less']
})
export class PacientePeriodicidadeListaComponent implements OnInit {
  registros: Object | null = null;

  @ViewChild('periodicidadeCadastro') 
  periodicidadeCadastro!: PessoaExamePeriodicidadeCadastroComponent;

  @ViewChild('grid') 
  grid!: GridComponent;

  selecaoModelo: SelectionSettingsModel = {
    enableToggle: false
  }

  filterSettings: FilterSettingsModel = {
    mode: 'Immediate',
    type: 'Excel'
  }

  searchSettings: SearchSettingsModel = {
    ignoreAccent: true,
    ignoreCase: true
  }
  
  constructor(private pacienteService: PacienteService) { }

  ngOnInit(): void {

  }

  carregar() {
    this.pacienteService.listarPeriodicidades().subscribe((periodicidades) => {
      this.registros = periodicidades;
    });
  }

  abrirSelecao() {
    let selecao = this.grid.getSelectedRecords()[0] as PessoaExamePeriodicidadeConsultaDto;
    this.periodicidadeCadastro.abrirConsultaOuEdicao(selecao.id);
  }
}
